// extracted by mini-css-extract-plugin
module.exports = {"sheet":"labelsheet_sheet__1DBIo","sticker":"labelsheet_sticker__8fxfO","info":"labelsheet_info__1Zuhc","labelSheet":"labelsheet_labelSheet__2jt7Z"};